module.exports = __webpack_public_path__ + "img/top-reason-support.a518a2d3.png";